import { useState, useRef, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { useAgreementDetails } from "../hooks/useAgreementDetails";
import EditButton from "../../../../components/EditButton";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import {
  agmtEditMainState,
  agmtSelectedRows,
  agmtEditState,
  agmtShowGroupState,
  agmtFullView,
  agmtRowData,
  agreementForEdit,
  agmtGrpFilterParams,
  isFilteredGroup,
  agmtToExpire,
  isFilteredState,
  agmtGrpFilterValues,
  editRenewedAgmt,
  enableGetCommQuery,
  conflictingAgreementId,
  filterConflictingAgreement,
  pendingEditRow,
} from "../atoms/atoms";
import { toast } from "../../../../components/toastNotification";
import CloseIconButton from "../../../../components/CloseIconButton";
import { AgmtFullViewModal } from "./AgmtFullViewModal";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useEditMainAgreement from "../hooks/useEditMainAgreement";
import useGroupSearchAgreements from "../hooks/useGroupSearchAgreements";
import useAddRenewedAgreements from "../hooks/useAddRenewedAgreements";
import AgreementForm from "../forms/AgreementForm";
import ConflictingDatesModal from "../../../../components/ConflictingDatesModal";

import {
  ArrowDownCircleIcon,
  FunnelIcon,
  InformationCircleIcon,
  NewspaperIcon,
} from "@heroicons/react/24/solid";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import { CSVLink } from "react-csv";
import GroupFilters from "./GroupFilters";
import AgrmtMasterEditForm from "../forms/AgrmtMasterEditForm";
import ConfirmBoxYesNo from "../../../../components/ConfirmBoxYesNo";
import { IAgreementDetails } from "../types";
import CustomLoader from "../../../../components/CustomLoader";
import { Truncate } from "./AgmtDetails";
import Tooltip from "react-tooltip";
export const AgmtGroupView = ({ mutateSearchAgreements, agmtRefetch }) => {
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_edit;
  const userPermissions = useRecoilValue(permissionsSelector);

  const [, setShowGroupView] = useRecoilState(agmtShowGroupState);
  const [agmtGroupDetails, setAgmtGroupDetails] = useState<IAgreementDetails[]>(
    []
  );
  const [, setAgmtRowDetails] = useRecoilState<any>(agmtRowData);
  const [showFullView, setShowFullView] = useRecoilState(agmtFullView);
  const [selectedAgmts, setSelectedAgmts] = useRecoilState(agmtSelectedRows);
  const [toExpire, setToExpire] = useRecoilState(agmtToExpire);
  const [isEditState, setEditState] = useRecoilState<boolean>(agmtEditState);
  const [, setRowToEdit] = useRecoilState(agreementForEdit);
  const [editMainState, setEditMainState] = useRecoilState(agmtEditMainState);
  const [updatedMainRow, setUpdatedMainRow] = useState<any>();
  const [isSaving, setIsSaving] = useState(false);
  const [openConfirmSave, setOpenConfirmSave] = useState(false);
  const [openConfirmNew, setOpenConfirmNew] = useState(false);
  const [mainOldAttachments, setMainOldAttachments] = useState<any[]>([]);
  const [mainNewAttachments, setMainNewAttachments] = useState();
  const [forDeleteAttachments, setForDeleteAttachments] = useState();
  const [filter, setFilter] = useState(false);
  const isFilteredMain = useRecoilValue(isFilteredState);
  const [isFiltered, setIsFiltered] = useRecoilState(isFilteredGroup);
  const [filterGrpParams, setFilterGrpParams] =
    useRecoilState<any>(agmtGrpFilterParams);
  const [, setGrpFilterFields] = useRecoilState(agmtGrpFilterValues);
  const [filteredAgmtDetails, setFilteredAgmtDetails] = useState([]);
  const [editRenewed, setEditRenewed] = useRecoilState(editRenewedAgmt);
  const [, setConflictingAgreementIds] = useRecoilState(conflictingAgreementId);
  const [isFilterConflictingAgreements, setFilterConflictingAgreements] =
    useRecoilState(filterConflictingAgreement);
  const [openConflictingDate, setOpenConflictingDate] = useState(false);
  const [pendingEditRowState, setPendingEditRow] =
    useRecoilState(pendingEditRow);

  const [, setEnableGetComm] = useRecoilState(enableGetCommQuery);
  const tableRef = useRef<any>();
  const { mutateAsync: updateMainAgreement } = useEditMainAgreement();
  const { mutateAsync: insertRenewedAgmts } = useAddRenewedAgreements();

  const getSelectedRows = (selectedRows) => {
    setSelectedAgmts(
      selectedRows
        .filter((x) => x.agreementIsActive)
        .map((x) => parseInt(x.agreementRepositoryId))
    );
  };

  const {
    mutateAsync: searchGroupAgreements,
    status: searchGrpAgmtStatus,
    data: filteredAgmtData,
    isLoading: filterAgmtDetailsLoading,
  } = useGroupSearchAgreements();

  const {
    isSuccess: getAgmtDetailsSuccess,
    data: agmtDetailsResult,
    isFetching: getAgmtDetailsLoading,
    refetch: getAgmtDetails,
  } = useAgreementDetails({ filterGrpParams });

  const searchAgreement = () => {
    setIsFiltered(true);
    searchGroupAgreements(filterGrpParams);
  };

  useEffect(() => {
    //Trigger get Agreement on load
    setIsFiltered(false);
    setFilter(false);
    setEditMainState(false);
    setEditState(false);
    setFilteredAgmtDetails([]);
    getAgmtDetails();
    refetchOnSuccess();
  }, []);

  useEffect(() => {
    if (getAgmtDetailsSuccess && agmtDetailsResult) {
      if (!agmtDetailsResult?.statusCode) {
        if (!isFiltered) {
          if (agmtDetailsResult?.length > 0) {
            if (editRenewed) {
              handleEditButton(agmtDetailsResult[0]);
            }
            setAgmtGroupDetails(
              agmtDetailsResult?.map((data) => ({
                ...data,
                state: data.state.split(",").join(","),
                newPercentage: parseFloat(data.newPercentage).toFixed(2),
                newPercentageConfie: parseFloat(
                  data.newPercentageConfie
                ).toFixed(2),
                newPercentageFranchise: parseFloat(
                  data.newPercentageFranchise
                ).toFixed(2),
                renewalPercentage: parseFloat(data.renewalPercentage).toFixed(
                  2
                ),
                renewPercentageConfie: parseFloat(
                  data.renewPercentageConfie
                ).toFixed(2),
                renewPercentageFranchise: parseFloat(
                  data.renewPercentageFranchise
                ).toFixed(2),
                flatRatePerPolicy: data.flatRatePerPolicy,
                newBusinessFlatRate: data.newBusinessFlatRate,
                renewFlatRate: data.renewFlatRate,
                //reformat dates for date inputs default value in edit mode
                effectiveDate: data.effectiveDate
                  ? new Date(data.effectiveDate).toISOString().split("T")[0]
                  : null,
                expirationDate: data.expirationDate
                  ? new Date(data.expirationDate).toISOString().split("T")[0]
                  : null,
              }))
            );
          } else {
            setAgmtGroupDetails([]);
          }
        }
      } else {
        toast.fire("Server Error", "Cannot Get Agreeement Data", "error");
        setAgmtGroupDetails([]);
      }
    }
  }, [agmtDetailsResult, getAgmtDetailsSuccess]);

  useEffect(() => {
    if (searchGrpAgmtStatus === "success" && filteredAgmtData) {
      if (filteredAgmtData.status === 200) {
        if (isFiltered) {
          if (filteredAgmtData?.data?.length > 0) {
            if (editRenewed) {
              handleEditButton(filteredAgmtData?.data[0]);
            }
            setFilteredAgmtDetails(
              filteredAgmtData?.data?.map((data) => ({ ...data }))
            );
          } else {
            setFilteredAgmtDetails([]);
          }
        }
      } else {
        toast.fire("Server Error", "Cannot Get Agreeement Data", "error");
        setFilteredAgmtDetails([]);
      }
    }
  }, [searchGrpAgmtStatus, filteredAgmtData]);

  useEffect(() => {
    if (pendingEditRowState) {
      handleEditButton(pendingEditRowState);

      setPendingEditRow(null);
    }
  }, [pendingEditRowState]);

  const onClickFullView = (row: any) => {
    setAgmtRowDetails(
      [row].map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      })[0]
    );
    setEnableGetComm(true);
    setShowFullView(true);
  };
  const closeFullView = () => {
    setShowFullView(false);
  };
  const handleMainEditButton = () => {
    //SET existing files from active rows
    agmtDetailsResult
      ?.filter((x) => x.agreementIsActive === true)
      .forEach((row) => {
        if (mainOldAttachments.length === 0 && row.sourceFiles) {
          mainOldAttachments.push(row.sourceFiles);
        } else if (mainOldAttachments.length > 0 && row.sourceFiles) {
          mainOldAttachments.forEach((main) => {
            if (main.sourceFileId !== row.sourceFiles.sourceFileId) {
              mainOldAttachments.push(row.sourceFiles);
            }
          });
        }
      });
    setEditMainState(true);
  };
  const saveMainData = (conflictingDates) => {
    setOpenConfirmSave(false);
    setOpenConfirmNew(false);
    setIsSaving(true);
    updateMainRowAgreement(conflictingDates);
  };
  const updateMainRowAgreement = (conflictingDates) => {
    updateMainAgreement(
      { ...updatedMainRow, isConflictingAgreement: conflictingDates },
      {
        onSuccess: (res) => {
          setIsSaving(false);
          if (res) {
            if (res.status === 201 || res.status === 200) {
              refetchOnSuccess();
              cancelMasterEdit();
              toast.fire(
                "Success",
                "Agreement updated successfully",
                "success"
              );
            } else if (res.data?.message === "Conflicting Dates") {
              setConflictingAgreementIds(res.data?.agreementIds);
              setOpenConflictingDate(true);
              setFilterConflictingAgreements(true);
            } else if (res.status === 500 || res.status === 400) {
              if (
                res.data.message === "Failed sending of email" ||
                res.data.message === "Failed inserting of notification"
              ) {
                cancelMasterEdit();
                toast.fire(
                  "Success",
                  "Agreement updated successfully, but " + res.data.message,
                  "warning"
                );
              } else {
                toast.fire(
                  "Updating Agreement Failed",
                  "Server Error: Cannot update Agreement, " + res.data.message,
                  "error"
                );
              }
            } else {
              toast.fire(
                "Updating Agreement Failed",
                "Server Error: Cannot update new Agreement",
                "error"
              );
            }
          }
        },
        onError: (error) => {
          setIsSaving(false);
          if (error) {
            toast.fire(
              "Updating new Agreement Failed",
              "Server Error: Cannot update new Agreement",
              "error"
            );
          }
        },
      }
    );
  };
  const saveRenewedAgreements = (conflictingDates) => {
    setOpenConfirmNew(false);
    setOpenConfirmSave(false);
    setIsSaving(true);
    updateMainRowAgreement(conflictingDates);
    insertRenewedAgmts(
      { ...updatedMainRow, isConflictingAgreement: conflictingDates },
      {
        onSuccess: (res) => {
          setIsSaving(false);
          if (res) {
            if (res.data?.message === "Conflicting Dates") {
              setConflictingAgreementIds(res.data?.agreementIds);
              setOpenConflictingDate(true);
            }
            if (res.status === 200) {
              refetchOnSuccess();
              setEditMainState(false);
              toast.fire(
                "Success",
                "Agreement/s added successfully",
                "success"
              );
            } else if (res.status === 500 || res.status === 400) {
              if (
                res.data.message === "Failed sending of email" ||
                res.data.message === "Failed inserting of notification"
              ) {
                cancelMasterEdit();
                toast.fire(
                  "Success",
                  "Agreement inserted successfully, but " + res.data.message,
                  "warning"
                );
              } else {
                toast.fire(
                  "Inserting Agreement Failed",
                  "Server Error: Cannot insert Agreement, " + res.data.message,
                  "error"
                );
              }
            } else {
              toast.fire(
                "Adding Agreement Failed",
                "Server Error: Cannot add new Agreement",
                "error"
              );
            }
          }
        },
        onError: (error) => {
          setIsSaving(false);
          if (error) {
            toast.fire(
              "Adding new Agreement Failed",
              "Server Error: Cannot add new Agreement",
              "error"
            );
          }
        },
      }
    );
  };

  const refetchOnSuccess = () => {
    if (isFilteredMain && !isFilterConflictingAgreements) {
      mutateSearchAgreements(true);
    } else if (isFilteredMain && isFilterConflictingAgreements) {
      mutateSearchAgreements(false);
    } else {
      agmtRefetch();
    }
    if (isFiltered) {
      searchAgreement();
    } else {
      getAgmtDetails();
    }
  };
  const cancelMasterEdit = () => {
    setSelectedAgmts([]);
    setMainOldAttachments([]);
    setMainNewAttachments(undefined);
    setForDeleteAttachments(undefined);
    setEditMainState(false);
    setToExpire(false);
    if (tableRef.current) {
      tableRef.current.onAllSelected(false);
    }
    isFiltered ? searchAgreement() : getAgmtDetails();
  };
  const closeGroupView = () => {
    setShowGroupView(false);
    setSelectedAgmts([]);
    setMainOldAttachments([]);
    setMainNewAttachments(undefined);
    setForDeleteAttachments(undefined);
    setEditMainState(false);
    setEditState(false);
    setAgmtGroupDetails([]);
    setFilteredAgmtDetails([]);
    setIsFiltered(false);
    setFilter(false);
    const defaultFilters = {
      AgreementRepositoryId: [],
      AgencyList: [],
      Carrier: [],
      Commission: null,
      EntityList: [],
      EffectiveDateTo: null,
      EffectiveDateFrom: null,
      ExpirationDate: null,
      AgreementIsActive: null,
      IsFranchise: null,
      PolicyType: [],
      SalesLead: null,
      State: [],
      masterLegalEntityId: null,
      isNewBusinessWriting: null,
      isWritingNewBusiness: null,
    };
    setFilterGrpParams(defaultFilters);
    setGrpFilterFields(defaultFilters);
    setEditRenewed(false);
  };

  const handleEditButton = (row) => {
    const states = row.state ? row.state.split(",") : [];
    const defaultStates = states?.map((state) => {
      return { label: state, value: state ? state : undefined };
    });

    const policyType = row.policyType ? row.policyType.split(",") : [];
    const defaultPolicyTypes = policyType.map((policyTypeName) => {
      return { label: policyTypeName, value: policyTypeName };
    });
    setEditState(true);
    setShowFullView(false);
    setRowToEdit({
      ...row,
      policyType: defaultPolicyTypes[0].value ? defaultPolicyTypes : null,
      //reformat dates for date inputs default value in edit mode
      effectiveDate: row.effectiveDate
        ? new Date(row.effectiveDate).toISOString().split("T")[0]
        : null,
      expirationDate: row.expirationDate
        ? new Date(row.expirationDate).toISOString().split("T")[0]
        : null,
      commissionEffectiveDate: row.commissionEffectiveDate
        ? new Date(row.commissionEffectiveDate).toISOString().split("T")[0]
        : null,
      state: defaultStates[0].value ? defaultStates : null,
      producerCode: row.producerCode ? row.producerCode : "",
      policyPrefix: row.policyPrefix ? row.policyPrefix : "",
      notes: row.notes ? row.notes : "",
      newPercentage: parseFloat(row.newPercentage).toFixed(2),
      renewalPercentage: parseFloat(row.renewalPercentage).toFixed(2),
      newPercentageConfie: parseFloat(row.newPercentageConfie).toFixed(2),
      newPercentageFranchise: parseFloat(row.newPercentageFranchise).toFixed(2),
      renewPercentageConfie: parseFloat(row.renewPercentageConfie).toFixed(2),
      renewPercentageFranchise: parseFloat(
        row.renewPercentageFranchise
      ).toFixed(2),
      overridePercentage: row.overridePercentage
        ? parseFloat(row.overridePercentage).toFixed(2)
        : null,
      overrideRenewalPercentage: row.overrideRenewalPercentage
        ? parseFloat(row.overrideRenewalPercentage).toFixed(2)
        : null,
    });
  };
  const groupedColumns = [
    {
      title: (
        <div className="w-40 text-primary text-xs font-semibold">
          {editMainState &&
          agmtGroupDetails?.filter((x) => x.agreementIsActive).length < 1 ? (
            <div className="text-red-500 font-normal italic">
              <span className="font-bold">Note:</span> No Active Agreement
            </div>
          ) : (
            <div>
              Selected Row/s{" "}
              <span className="inline-block font-bold">
                ({selectedAgmts.length})
              </span>
            </div>
          )}
        </div>
      ),
      field: "agreementRepositoryId",
      render: (row) => {
        return (
          <div className="cursor-pointer flex flex-col">
            <div
              className={"blueAndBold underline"}
              onClick={() => onClickFullView(row)}
            >
              {row.agreementRepositoryId}
            </div>
            <div className="mainLabeltextColor">Agreement Id</div>
          </div>
        );
      },
    },
    {
      //title: "Agency",
      field: "agency",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">{row.agency} </div>
            <div className="mainLabeltextColor">Agency</div>
          </div>
        );
      },
    },
    {
      //title: "Legal Entity",
      field: "entityName",
      width: "20%",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.entityName ? (
                row.entityName
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Legal Entity</div>
          </div>
        );
      },
    },
    {
      field: "masterLegalEntityId",
      width: "20%",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.masterEntityName ? (
                row.masterEntityName
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor"> Master Legal Entity</div>
          </div>
        );
      },
    },
    {
      // title: "State",
      field: "state",
      options: {},
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.state ? (
                row?.state?.split(",").join(", ")
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">State</div>
          </div>
        );
      },
    },
    {
      // title: "Standard",
      field: "standard",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.standard ? (
                row.standard === "null" || row.standard === "unspecified" ? (
                  <span className="undefineTextColor">unspecified</span>
                ) : (
                  row.standard
                )
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Standard</div>
          </div>
        );
      },
    },
    {
      // title: "Paid Type",
      field: "paidType",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.paidType ? (
                row.paidType
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Paid Type</div>
          </div>
        );
      },
    },
    {
      // title: "Policy Type",
      field: "policyType",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.policyType ? (
                row?.policyType?.split(",").join(", ")
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}{" "}
            </div>{" "}
            <div className="mainLabeltextColor">policy Type</div>{" "}
          </div>
        );
      },
    },
    {
      //title: "Code",
      field: "producerCode",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.producerCode ? (
                row.producerCode === "null" ||
                row.producerCode === "unspecified" ? (
                  <span className="undefineTextColor">unspecified</span>
                ) : (
                  Truncate({ text: row.producerCode, length: 15 })
                )
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Producer Code</div>{" "}
          </div>
        );
      },
    },

    {
      // title: "Policy Type",
      field: "policyPrefix",
      render: (row) => {
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.policyPrefix ? (
                row?.policyPrefix?.split(",").join(", ")
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}{" "}
            </div>{" "}
            <div className="mainLabeltextColor">policy Prefix</div>{" "}
          </div>
        );
      },
    },

    {
      //title: "Status",
      field: "agreementIsActive",
      render: (row) => {
        let expDate = row.expirationDate
          ? new Date(
              new Date(row.expirationDate).toLocaleDateString("en-US", {
                timeZone: "UTC",
              })
            )
          : "";
        let dateToday = new Date();
        return (
          <div className=" flex  flex-col">
            <div className="font-medium">
              {row.agreementIsActive &&
              row.expirationDate &&
              expDate >= dateToday
                ? "Active"
                : !row.agreementIsActive &&
                  row.expirationDate &&
                  row.expirationDate &&
                  expDate >= dateToday
                ? "Inactive"
                : (row.agreementIsActive || !row.agreementIsActive) &&
                  row.expirationDate &&
                  expDate < dateToday
                ? "Expired"
                : row.agreementIsActive
                ? "Active"
                : "Inactive"}
            </div>
            <div className="mainLabeltextColor">Agreement Status</div>{" "}
          </div>
        );
      },
    },

    {
      name: "Action/s",
      left: true,
      hidden: !userPermissions.includes(editPermission) || editMainState,
      render: (groupedData) => {
        return (
          <EditButton
            onClick={() => {
              handleEditButton(groupedData);
            }}
            buttonText={"Edit"}
            className={"h-6"}
            disabled={false}
          />
        );
      },
    },
  ];
  let dateTimeToday = new Date(new Date().toISOString()).toLocaleDateString(
    "en-US",
    {
      timeZone: "UTC",
    }
  );

  const forDownload = isFiltered ? filteredAgmtDetails : agmtGroupDetails;
  const csvReport = {
    filename: "AgreementReport_" + dateTimeToday + ".csv",
    data: forDownload.map((data: any) => {
      let dateToday = data.expirationDate
        ? new Date(
            new Date().toLocaleDateString("en-US", {
              timeZone: "UTC",
            })
          )
        : "";
      let expDate = data.expirationDate
        ? new Date(
            new Date(data.expirationDate).toLocaleDateString("en-US", {
              timeZone: "UTC",
            })
          )
        : "";
      return {
        agreementRepositoryId: data.agreementRepositoryId,
        carrier: data.carrier,
        state: data.state,
        agency: data.agency,
        entityName: data.entityName,
        masterLegalEntity: data.masterEntityName,
        entityEIN: data.entityEIN,
        licenseNumber: data.licenseNumber,
        newPercentage: data.newPercentage,
        newPercentageConfie: data.newPercentageConfie,
        newPercentageFranchise: data.newPercentageFranchise,
        renewalPercentage: data.renewalPercentage,
        renewPercentageConfie: data.renewPercentageConfie,
        renewPercentageFranchise: data.renewPercentageFranchise,
        flatRatePerPolicy: data.flatRatePerPolicy,
        newBusinessFlatRate: data.newBusinessFlatRate,
        renewalFlatRate: data.renewalFlatRate,
        effectiveDate: new Date(data.effectiveDate).toLocaleDateString(
          "en-US",
          {
            timeZone: "UTC",
          }
        ),
        expirationDate: data.expirationDate
          ? new Date(data.expirationDate).toLocaleDateString("en-US", {
              timeZone: "UTC",
            })
          : null,
        "Agreement Status":
          data.expirationDate && data.agreementIsActive && expDate >= dateToday
            ? "Active"
            : data.expirationDate &&
              (!data.agreementIsActive || data.agreementIsActive) &&
              expDate < dateToday
            ? "Expired"
            : data.expirationDate &&
              !data.agreementIsActive &&
              expDate >= dateToday
            ? "Inactive"
            : data.agreementIsActive
            ? "Active"
            : "Inactive",
        usedInCommVal: data.isActive === true ? "True" : "False",
        isFranchise: data.isFranchise,
        program: data.program,
        standard: data.standard,
        paidType: data.paidType,
        policyType: data.policyType,
        policyPrefix: data.policyPrefix,
        notes: data.notes,
        licensedType: data.licensedType,
        producerCode: data.producerCode,
        agreementType: data.agreementType,
        appointedBy: data.planCode,
        term: data.term,
        otherInsurance: data.otherInsurance,
        pifMax: data.pifMax,
        pifMin: data.pifMin,
        otherCommissionPercentage: data.otherCommissionPercentage,
        otherCommissionTransaction: data.otherCommissionTransaction,
        billing: data.billing,
        paymentRemittanceType: data.paymentRemittanceType,
        commissionPaymentsFrequency: data.commissionPaymentsFrequency,
        contingentCommission: data.contingentCommission,
        sourceFiles: data?.sourceLink,
        salesLeadId: data.salesLead,
        salesLeadName: data.salesLeadName,
        licenseTypeName: data.licenseTypeName,
        businessTypeName: data.businessTypeName,
        lineOfBusinessName: data.lineOfBusinessName,
        commissionUpdatedBy: data.commissionUpdatedBy,
        commissionUpdatedOn: data.commissionUpdatedOn,
        isOverridePayment: data?.isOverridePayment,
        overridePaymentType: data?.overridePaymentType,
        overridePercentage: data?.overridePercentage,
        overrideRenewalPercentage: data?.overrideRenewalPercentage,
        createdOn: data.createdOn
          ? new Date(data.createdOn).toLocaleDateString("en-US", {
              timeZone: "UTC",
            })
          : null,
        createdBy: data.createdBy,
        modifiedOn: data.updatedOn
          ? new Date(data.updatedOn).toLocaleDateString("en-US", {
              timeZone: "UTC",
            })
          : null,
        modifiedBy: data.updatedBy,
      };
    }),
  };
  if (getAgmtDetailsLoading && !agmtDetailsResult) {
    return (
      <div className="p-4">
        <CustomLoader />
      </div>
    );
  }
  return (
    <>
      {!isEditState && (
        <div className="relative w-full text-xs py-4 box-shadow border-quinary border-l-2">
          <>
            <CloseIconButton onClick={() => closeGroupView()} />
            <div className="mx-4 rounded-lg box-shadow grid grid-row">
              {editMainState ? (
                <div className="mainedit-form">
                  <AgrmtMasterEditForm
                    agmtGroupDetails={agmtGroupDetails}
                    isSaving={isSaving}
                    cancelEdit={cancelMasterEdit}
                    setOpenConfirmSave={setOpenConfirmSave}
                    mainNewAttachments={mainNewAttachments}
                    forDeleteAttachments={forDeleteAttachments}
                    setUpdatedMainRow={setUpdatedMainRow}
                    mainOldAttachments={mainOldAttachments}
                    setMainOldAttachments={setMainOldAttachments}
                    setMainNewAttachments={setMainNewAttachments}
                    setForDeleteAttachments={setForDeleteAttachments}
                  />
                </div>
              ) : (
                <div className="p-2">
                  <div>
                    <div className="w-full flex items-center space-x-2">
                      <div>
                        <NewspaperIcon className="text-white bg-blue-500 rounded-md h-10 w-10 p-1" />
                      </div>
                      <div className="text-xs text-gray-600 font-medium">
                        <label>Agreements</label>
                        <div className="flex items-center font-bold blueAndBold">
                          {agmtGroupDetails[0]?.carrier}
                        </div>
                        <div className="flex items-center justify-between gap-x-4">
                          <div className="flex gap-x-2">
                            <label>Effective Date:</label>
                            <div>
                              {agmtGroupDetails[0]?.effectiveDate
                                ? new Date(
                                    agmtGroupDetails[0]?.effectiveDate
                                  ).toLocaleDateString("en-US", {
                                    timeZone: "UTC",
                                  })
                                : "unspecified"}
                            </div>
                          </div>
                          <div className="border-r-2 border-gray-500 h-5"></div>
                          <div className="flex gap-x-2">
                            <label>Expiration Date:</label>
                            <div>
                              {agmtGroupDetails[0]?.expirationDate
                                ? new Date(
                                    agmtGroupDetails[0]?.expirationDate
                                  ).toLocaleDateString("en-US", {
                                    timeZone: "UTC",
                                  })
                                : "unspecified"}
                            </div>
                          </div>
                          <div className="border-r-2 border-gray-500 h-5"></div>
                          <div className="flex gap-x-2 items-center w-60">
                            <label>State:</label>

                            <div className="truncate">
                              {agmtGroupDetails[0]?.state || "unspecified"}
                            </div>

                            <div className="relative flex items-center">
                              {agmtGroupDetails[0]?.state &&
                                agmtGroupDetails[0]?.state.length > 30 && (
                                  <>
                                    <Tooltip
                                      id="states"
                                      place="top"
                                      effect="solid"
                                      type="info"
                                      border={true}
                                      arrowColor="#0078d7"
                                      borderColor="#0078d7"
                                      backgroundColor="white"
                                      textColor="#0078d7"
                                      className="custom-tooltip"
                                    >
                                      <span className="whitespace-normal break-words">
                                        {agmtGroupDetails[0]?.state}
                                      </span>
                                    </Tooltip>
                                    <InformationCircleIcon
                                      data-tip={
                                        agmtGroupDetails[0]?.state ||
                                        "unspecified"
                                      }
                                      data-for="states"
                                      className="text-primary h-5 w-5 cursor-pointer"
                                    />
                                  </>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-between items-center py-2">
                    {agmtGroupDetails[0]?.flatRatePerPolicy ? (
                      <div className="flex flex-row space-x-2">
                        <div className="rounded-lg border border-quinary">
                          <div className="flex flex-row p-1 space-x-2">
                            <div className="rounded bg-quinary text-white p-1">
                              Flat Rate Per Policy:{" "}
                              {agmtGroupDetails[0]?.flatRatePerPolicy
                                ? "True"
                                : "False"}
                            </div>
                            <div className="rounded bg-sky-200 text-primary p-1">
                              New Flat Rate:{" "}
                              {"$" + agmtGroupDetails[0]?.newBusinessFlatRate
                                ? agmtGroupDetails[0]?.newBusinessFlatRate?.toFixed(
                                    2
                                  )
                                : 0}
                            </div>
                          </div>
                        </div>
                        <div className="rounded-lg border border-secondary">
                          <div className="flex flex-row p-1 space-x-2">
                            <div className="rounded bg-secondary text-white p-1">
                              Renewal Flat Rate:{" "}
                              {"$" + agmtGroupDetails[0]?.renewalFlatRate
                                ? agmtGroupDetails[0]?.renewalFlatRate?.toFixed(
                                    2
                                  )
                                : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-row space-x-2">
                        <div className="rounded-lg border border-quinary">
                          <div className="flex flex-row p-1 space-x-2">
                            <div className="rounded bg-quinary text-white p-1">
                              New %: {agmtGroupDetails[0]?.newPercentage}
                            </div>
                            <div className="rounded bg-sky-200 text-primary p-1">
                              Confie %:{" "}
                              {agmtGroupDetails[0]?.newPercentageConfie}
                            </div>
                            {agmtGroupDetails[0]?.isFranchise && (
                              <div className="rounded bg-sky-200 text-primary p-1">
                                Franchise %:{" "}
                                {agmtGroupDetails[0]?.newPercentageFranchise}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="rounded-lg border border-secondary">
                          <div className="flex flex-row p-1 space-x-2">
                            <div className="rounded bg-secondary text-white p-1">
                              Renew %: {agmtGroupDetails[0]?.renewalPercentage}
                            </div>
                            <div className="rounded bg-pink-200 text-secondary p-1">
                              Confie %:{" "}
                              {agmtGroupDetails[0]?.renewPercentageConfie}
                            </div>
                            {agmtGroupDetails[0]?.isFranchise && (
                              <div className="rounded bg-pink-200 text-secondary p-1">
                                Franchise %:{" "}
                                {agmtGroupDetails[0]?.renewPercentageFranchise}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="flex flex-row justify-items-center space-x-2">
                      {userPermissions.includes(editPermission) && (
                        <EditOutlineButton
                          onClick={() => {
                            handleMainEditButton();
                          }}
                          buttonText={"Edit"}
                          className={undefined}
                          disabled={false}
                        />
                      )}

                      <CSVLink
                        className="border-quinary shadow-md text-quinary group relative flex 
                      justify-center items-center py-1 px-3 border text-xs font-medium rounded-full
                       hover:bg-quinary hover:text-white "
                        {...csvReport}
                      >
                        <ArrowDownCircleIcon className="h-4 w-4 mr-2" />{" "}
                        Download File
                      </CSVLink>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="p-4">
              <button
                disabled={getAgmtDetailsLoading || isEditState}
                className="disabled:opacity-25 disabled:cursor-not-allowed hover:scale-90 
              focus:bg-primary focus:text-white flex justify-center items-center shadow-md px-3  h-7 text-xs gap-x-2 font-semibold text-primary border 
              hover:bg-primary selected hover:text-white border-primary rounded-md "
                onClick={() => {
                  setFilter(!filter);
                }}
              >
                <div>Filter By</div>
                <FunnelIcon className="h-3 w-3" />
              </button>
            </div>
            <div className="flex justify-between">
              {filter && <GroupFilters searchAgreement={searchAgreement} />}
              {/* {!showFullView && ( */}
              <div className="w-full h-5/6 bg-white overflow-auto mx-4 rounded-lg box-shadow grid grid-row">
                <div className="">
                  <MaterialTableTS
                    data={isFiltered ? filteredAgmtDetails : agmtGroupDetails}
                    columns={groupedColumns}
                    toolbarSearch={false}
                    isLoading={
                      getAgmtDetailsLoading || filterAgmtDetailsLoading
                    }
                    selection={editMainState}
                    onSelectionChange={getSelectedRows}
                    tableRef={tableRef}
                    showHeader={editMainState}
                    headerStyle={{
                      backgroundColor: "#FFFFFF",
                      fontSize: "12px",
                      padding: "0px",
                    }}
                    rowStyle={{
                      fontSize: "12px",
                    }}
                  />
                </div>
              </div>
              {/* )} */}
            </div>
          </>
        </div>
      )}
      {showFullView && (
        <AgmtFullViewModal
          showFullView={showFullView}
          closeFullView={closeFullView}
          handleEditButton={handleEditButton}
        />
      )}

      {isEditState && (
        <AgreementForm
          getAgmtRefetch={isFiltered ? searchAgreement : getAgmtDetails}
        />
      )}
      <ConfirmBoxModal
        ModalTitle={"Edit Agreement"}
        qConfirmation={
          toExpire
            ? "Are you sure you want to update and expire this group?"
            : "Are you sure you want to update this group?"
        }
        isOpen={openConfirmSave}
        onClose={() => setOpenConfirmSave(false)}
        onClickFunction={() => {
          if (toExpire) {
            setOpenConfirmNew(true);
          } else {
            saveMainData(true);
          }
        }}
        cancelButtonRef={undefined}
      />
      <ConfirmBoxYesNo
        ModalTitle={"Renew Agreement"}
        qConfirmation={`Do you want to create new Agreement/s for this Carrier?`}
        isOpen={openConfirmNew}
        onClose={() => saveMainData(true)}
        onClickFunction={() => {
          saveRenewedAgreements(true);
        }}
      />
      <ConflictingDatesModal
        ModalTitle={"Conflicting Effective Dates"}
        qConfirmation={`There's an existing agreement with conflicting effective dates. Please set the Effective date to other dates or Expired the other agreement`}
        isOpen={openConflictingDate}
        onClose={() => setOpenConflictingDate(false)}
        onClickFunction={(event) => {
          setOpenConflictingDate(false);
          setShowGroupView(false);
          event.preventDefault();
          setEditMainState(false);
          setEditState(false);
          setToExpire(false);
          isFilteredMain ? mutateSearchAgreements(false) : agmtRefetch();
        }}
        onClickProceed={() => {
          toExpire ? saveRenewedAgreements(false) : saveMainData(false);
          setOpenConflictingDate(false);
        }}
      />
    </>
  );
};
